export class DrugMatchVerification {
  id?: number;
  matches: boolean;
  notes: string;
  ndc: string;
  drugGroupId: number;
  referenceNumber: string;
  frozen: boolean;
}
